import { DropdownOption } from '../../../shared/types';

/**
 * Input payload for dynamic dropdown option mapping.
 */
type SetDropdownOptionsProps = {
  field: string;
  options?: DropdownOption[];
};

/**
 * Disables the "No" option for active attribute handling in PSP Management.
 */
const disableNoOption = (item: DropdownOption): DropdownOption => {
  const label = item?.label?.toString().toLowerCase();
  const isNoOption = label === 'no' || item?.value == 0;
  return isNoOption ? { ...item, disabled: true } : item;
};

/**
 * Field-specific option transformers.
 * Key: attribute internal name
 * Value: option mapper applied to each option item
 */
const FIELD_OPTION_MAPPERS: Record<string, (item: DropdownOption) => DropdownOption> = {
  active: disableNoOption,
};

/**
 * Applies field-specific dropdown option transformations for PSP Management.
 *
 * If no mapper is registered for the field, the original options are returned.
 *
 * @param props.field Attribute internal name used to resolve a mapper.
 * @param props.options Dropdown options to transform.
 * @returns Transformed options when a mapper exists, otherwise the original options.
 */
export const setPspManagementDropdownOptions = ({
  field,
  options = [],
}: SetDropdownOptionsProps): DropdownOption[] => {
  const mapper = FIELD_OPTION_MAPPERS[field];
  return mapper ? options.map(mapper) : options;
};
